import {combineReducers} from "@reduxjs/toolkit";
import authSlice from "slices/auth";
import {notificationSlice} from "slices/notification";
import {emailLogsSlice} from "slices/emailLogs";
import {mobilePushSlice} from "slices/mobilePush";
import {slackSlice} from "slices/slack";
import {teamsSlice} from "slices/teams";
import {tenantIdsSlice} from "slices/tenantIds";

export const rootReducer = combineReducers({
    auth: authSlice.reducer,
    slack: slackSlice.reducer,
    teams: teamsSlice.reducer,
    notification: notificationSlice.reducer,
    emailLogs: emailLogsSlice.reducer,
    mobilePush: mobilePushSlice.reducer,
    tenantIds: tenantIdsSlice.reducer,
})
